import React from 'react';

const PrivateUniverIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9254 23.4351V0.576768H3.97352C3.48772 0.525631 2.51612 0.755748 2.51612 2.08531V13.3866C2.43941 14.077 2.59793 15.8259 3.84568 17.2986C5.40537 19.1396 9.75196 22.668 11.9254 23.4351Z"
      fill="white"
    />
    <path
      d="M11.9254 23.4351C13.5106 22.668 17.2948 20.4691 19.7493 17.81C20.3459 17.2134 21.534 15.4935 21.5136 13.3866C21.4931 11.2798 21.5051 4.78706 21.5136 1.80406C21.5051 1.39496 21.1761 0.576768 19.9283 0.576768H11.9254V23.4351Z"
      fill="#A1A5AC"
    />
    <path
      d="M12.4361 15.7863C12.7839 15.6431 15.2572 14.8062 16.4504 14.4056C16.5953 14.3374 16.8851 14.0681 16.8851 13.5362C16.8851 13.0044 16.8781 11.049 16.8746 10.1378C15.4751 10.6454 13.3062 11.4195 12.0271 11.8743V15.8652C12.1592 15.8633 12.3011 15.8419 12.4361 15.7863Z"
      fill="white"
    />
    <path
      d="M12.0271 11.8743L7.16899 10.1378V13.3828C7.15195 13.647 7.23547 14.2215 7.70593 14.4056C8.1764 14.5897 10.4588 15.4028 11.5412 15.7863C11.6351 15.8228 11.8189 15.8682 12.0271 15.8652V11.8743Z"
      fill="#ECECEC"
    />
    <path
      d="M12.6151 6.3259C12.0833 6.10089 11.6265 6.23214 11.4646 6.3259L6.37637 8.16685C6.13774 8.19241 5.63492 8.36117 5.53265 8.83163C5.43037 9.30209 5.8139 9.62426 6.01845 9.72653L7.16899 10.1378L12.0271 11.8743C13.3062 11.4195 15.4751 10.6454 16.8746 10.1378C17.5732 9.88444 18.0801 9.6975 18.1891 9.64982C18.5982 9.47084 18.5471 8.88277 18.4704 8.65265C18.409 8.46855 18.0868 8.30321 17.9334 8.24355C16.3822 7.69808 13.147 6.5509 12.6151 6.3259Z"
      fill="#FFF8F8"
    />
  </svg>
);

export default PrivateUniverIcon;
